module.exports = __webpack_public_path__ + "static/media/24UHCHR5.c30b3e81.jpg";